module.exports = __webpack_public_path__ + "img/page_banner.22ad23b0.png";